import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ConversacionesService} from '../conversaciones.service';
import {ComunicadosAvisoDialogComponent} from './comunicados-aviso-dialog.component';

/**
 * Aviso al entrar: si hay comunicados de CNC Dental sin leer, los enseña en un diálogo que solo se
 * cierra con «Entendido» (ComunicadosAvisoDialogComponent). Lo llama la cabecera, una vez por carga
 * de la app (HeaderComponent._conectarAvisos(), donde ya hay perfil). Un comunicado que llegue con
 * la sesión abierta no pasa por aquí: solo actualiza el resumen y la bandeja (vía cambios$).
 */
@Injectable({providedIn: 'root'})
export class ComunicadosAvisoService {
    /**
     * La API rechaza con 400 un PATCH .../leidos con más de 100 ids (ver DecoradorLimiteIds o
     * equivalente en el controlador): el diálogo manda TODOS los que muestra de una vez («Entendido»),
     * así que nunca se le pueden pasar más de estos. El resto de no leídos aparecerá en la próxima
     * carga de la app.
     */
    static readonly MAXIMO_EN_AVISO = 100;

    private _revisado = false;

    constructor(private _conversaciones: ConversacionesService, private _dialogo: MatDialog) {
    }

    revisar(): void {
        if (this._revisado) {
            return;
        }
        this._revisado = true;
        this._conversaciones.comunicados(true).subscribe({
            next: comunicados => {
                const noLeidos = comunicados.filter(c => !c.leido)
                    .sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime())
                    .slice(0, ComunicadosAvisoService.MAXIMO_EN_AVISO);
                if (noLeidos.length > 0) {
                    this._dialogo.open(ComunicadosAvisoDialogComponent, {
                        disableClose: true, width: '640px', maxWidth: '90vw', data: {comunicados: noLeidos}
                    });
                }
            },
            // Si falla, no se reintenta en esta carga de la app (el servicio es un singleton de toda
            // la SPA): hará falta recargar la página para que vuelva a comprobarlo.
            error: () => null
        });
    }
}
